import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { Grid, InputLabel } from "@material-ui/core";

import { MiscellaneousIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { LabledTextField } from "../core/LabledTextField";

export const IncreaseCurrentElectricMiscellaneousForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_CURRENT_ELECTRIC_MISCELLANEOUS>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<MiscellaneousIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 8 }}>
                        Sonstige Verbraucher
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentElectricMiscellaneous.value.installed}
                        {...getFieldProps("increaseCurrentElectricMiscellaneous.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseCurrentElectricMiscellaneous.value.installed =
                                    checked;
                                values.increaseCurrentElectricMiscellaneous.value.description = checked ? "" : null;
                                values.increaseCurrentElectricMiscellaneous.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentElectricMiscellaneous.value.installed}
                detail={
                    <Fragment>
                        <Grid
                            container
                            spacing={4}
                            alignItems="flex-end"
                            style={{ paddingBottom: "12px" }}
                        >
                            <Grid item xs={12} md={8}>
                                <LabledTextField
                                    label="Bezeichnung"
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                    placeholder="Motoren, Schweißgeräte, etc."
                                    InputProps={{
                                        className: classes.textField,
                                        style: { width: "100%" },
                                        inputProps: {
                                            style: { fontFamily: "innogyWeb" },
                                        },
                                    }}
                                    inputProps={{
                                        maxLength: 100,
                                    }}
                                    value={
                                        values.increaseCurrentElectricMiscellaneous.value
                                            .description
                                    }
                                    onChange={(v) =>
                                        setValues((values) => {
                                            values.increaseCurrentElectricMiscellaneous.value.description =
                                                v.target.value;
                                        })
                                    }
                                    error={!!values.increaseCurrentElectricMiscellaneous.error}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputLabel className={classes.labledTextfieldLabel}>
                                    Summe der Leistung
                                </InputLabel>
                                <NumberInput
                                    className={classes.textField}
                                    style={{ width: "100%" }}
                                    fixedDecimalScale={false}
                                    allowLeadingZeros={false}
                                    decimalScale={
                                        values.increaseCurrentElectricMiscellaneous.value.demand
                                            .precision
                                    }
                                    isNumericString={false}
                                    allowNegative={false}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    adornment={
                                        values.increaseCurrentElectricMiscellaneous.value.demand
                                            .unit
                                    }
                                    value={
                                        values.increaseCurrentElectricMiscellaneous.value.demand
                                            .amount || ""
                                    }
                                    placeholder="0"
                                    onValueChange={(v) =>
                                        setValues((values) => {
                                            values.increaseCurrentElectricMiscellaneous.value.demand.amount =
                                                v.floatValue || null;
                                        })
                                    }
                                    error={!!values.increaseCurrentElectricMiscellaneous.error && !values.increaseCurrentElectricMiscellaneous.value.notKnown}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    style={{ marginTop: -12 }}
                                    isCheckBox={true}
                                    control={
                                        <Checkbox
                                            value="ja"
                                            checked={
                                                values.increaseCurrentElectricMiscellaneous.value
                                                    .notKnown
                                            }
                                            onChange={(event, checked) =>
                                                setValues((values) => {
                                                    values.increaseCurrentElectricMiscellaneous.value.notKnown =
                                                        checked;
                                                })
                                            }
                                        />
                                    }
                                    label="Leistungswert nicht bekannt"
                                    error={false}
                                />
                            </Grid>
                        </Grid>
                    </Fragment>
                }
            />
        </Fragment>
    );
};
